export const CaseSearchData = [
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      {
        id: "im_name",
        label: "Assigned IM.",
        align: "left",
        width: "150px",
        color: "#59ce8f",
        fontWeight: "bold",
      },
      {
        id: "registration_no",
        label: "Registration No.",
        align: "left",
        width: "150px",
      },
      {
        id: "product",
        label: "Product",
        align: "left",
      },
      {
        id: "sub_product",
        label: "Sub Product",
        align: "center",
      },
      {
        id: "loss_city",
        label: "Loss City",
        align: "center",
      },

      {
        id: "source",
        label: "Source",
        align: "left",
      },
      {
        id: "status",
        label: "Status",
        align: "left",
      },
      {
        id: "view",
        label: "",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 1,
        case_id: 25,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 2,
        case_id: 26,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 3,
        case_id: 27,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 4,
        case_id: 28,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 5,
        case_id: 29,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 6,
        case_id: 30,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 7,
        case_id: 31,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 8,
        case_id: 32,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 9,
        case_id: 33,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
      {
        srNo: 10,
        case_id: 34,
        claim_number: "C1234567890",
        policy_number: "1234567890",
        registration_number: "1234567890",
        product_name: "Motor",
        sub_product_name: "-",
        loss_city: "KARNATAKA",
        source: "CIMA 2.0",
        status: "-",
      },
    ],
  },
];

export const CaseSearchViewData = [
  {
    column: {
      open: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
        },
        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "product",
          label: "Product",
          align: "left",
        },
        {
          id: "sub_product",
          label: "Sub Product",
          align: "left",
        },
        {
          id: "loss_location",
          label: "Loss State",
          align: "left",
        },
        {
          id: "loss_city",
          label: "Loss City",
          align: "left",
        },
        {
          id: "assigned_by_user_date",
          label: "Assigned Date",
          align: "left",
        },
        {
          id: "claim_registration_date",
          label: "Reg Date",
          align: "left",
          width: "90px",
        },
        {
          id: "severity",
          label: "Severity",
          align: "left",
        },
        {
          id: "tat",
          label: "TAT",
          align: "center",
        },
        // {
        //   id: "segmentation",
        //   label: "Customer Segment",
        //   align: "left",
        // },
        // {
        //   id: "claim_intimation_type",
        //   label: "Claim Intimation Type",
        //   align: "center",
        //   minWidth: "130px",
        // },
        {
          id: "alert",
          label: "Alert",
          align: "center",
        },
      ],
      allocated: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          width: "130px",
        },

        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        {
          id: "product",
          label: "Product",
          align: "left",
        },
        {
          id: "loss_location",
          label: "Loss Location",
          align: "left",
        },
        {
          id: "assigned_by_user_date",
          label: "Assigned Date",
          align: "left",
        },
        {
          id: "ageing",
          label: "Ageing",
          align: "left",
        },
        {
          id: "Vendor Name",
          label: "Vendor Name",
          align: "left",
        },
        {
          id: "investigator_name",
          label: "Investigator Name",
          align: "left",
        },
        {
          id: "segmentation",
          label: "Customer Segment",
          align: "left",
        },
      ],
      qc: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          width: "130px",
        },
        {
          id: "policy_number",
          label: "Policy No.",
          align: "left",
        },
        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "customer_type",
          label: "Customer Type",
          align: "left",
        },
        {
          id: "claim_registration_date",
          label: "Claim Registration Date",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        {
          id: "product_category",
          label: "Product Category",
          align: "left",
        },
        // {
        //   id: "trigger_source",
        //   label: "Trigger Source",
        //   align: "center",
        // },
        {
          id: "severity",
          label: "Severity",
          align: "left",
        },
        {
          id: "policy_location",
          label: "Policy Location",
          align: "left",
        },
        {
          id: "zone",
          label: "Zone",
          align: "left",
        },
        // {
        //   id: "policy_location",
        //   label: "Field Investigation Completion Date",
        //   align: "left",
        // },
        {
          id: "tat",
          label: "TAT",
          align: "center",
        },
      ],
      recommended: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          width: "130px",
        },

        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        {
          id: "product_name",
          label: "Product",
          align: "left",
        },
        {
          id: "loss_location",
          label: "Loss Location",
          align: "left",
        },
        {
          id: "recommendation_date",
          label: "Recommendation Date",
          align: "center",
        },
        {
          id: "ageing",
          label: "Ageing",
          align: "left",
        },

        {
          id: "rlm_recommendation",
          label: "RLM Recommendation ",
          align: "center",
        },
        {
          id: "qc_status",
          label: "QC Status",
          align: "center",
        },
        {
          id: "recommendation_status",
          label: "Recommendation Status",
          align: "center",
        },
        {
          id: "recommendation_of",
          label: "Recommendation Of",
          align: "center",
        },
      ],
      submitted: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          width: "130px",
        },
        {
          id: "policy_number",
          label: "Policy No",
          align: "left",
        },

        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "customer_type",
          label: "Customer Type",
          align: "left",
        },
        {
          id: "registration_date",
          label: "Claim Registration Date",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        {
          id: "tigger_source",
          label: "Trigger Source",
          align: "center",
        },
        {
          id: "severity",
          label: "severity",
          align: "left",
        },
        {
          id: "im_name",
          label: "IM",
          align: "left",
          color: "red",
          fontWeight: "500",
        },
        {
          id: "qc_name",
          label: "QC",
          align: "left",
          color: "red",
          fontWeight: "500",
        },
        {
          id: "rm_name",
          label: "RM",
          align: "left",
          color: "red",
          fontWeight: "500",
        },
        {
          id: "nm_name",
          label: "NM",
          align: "left",
          color: "#4DC84D",
          fontWeight: "500",
        },
        {
          id: "nh_name",
          label: "NH",
          align: "left",
          fontWeight: "500",
          color: "#4DC84D",
        },
        {
          id: "qc_final_status",
          label: "QC Final Status",
          align: "center",
        },
        {
          id: "sendReminder",
          label: "Send Reminder",
          align: "left",
          fontWeight: "500",
          color: "#1395CC",
        },
        {
          id: "concludedat",
          label: "Closure Date",
          align: "left",
          minWidth: "100px",
        },
      ],
      rejected: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          width: "130px",
        },
        {
          id: "policy_number",
          label: "Policy No",
          align: "left",
        },

        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "customer_type",
          label: "Customer Type",
          align: "left",
        },
        {
          id: "claim_registration_date",
          label: "Claim Registration Date",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        {
          id: "tigger_source",
          label: "Trigger Source",
          align: "center",
        },
        {
          id: "severity",
          label: "severity",
          align: "left",
        },
        {
          id: "loss_location",
          label: "Loss Location",
          align: "left",
        },
        {
          id: "subProduct",
          label: "Sub Product",
          align: "center",
        },

        {
          id: "qc_level1",
          label: "IM/QC",
          align: "left",
          fontWeight: "500",
          color: "red",
        },
        {
          id: "qc_level2",
          label: "RM",
          align: "left",
          fontWeight: "500",
          color: "red",
        },
        {
          id: "qc_level3",
          label: "NM",
          align: "left",
          fontWeight: "500",
          color: "red",
        },
        {
          id: "qc_final_status",
          label: "QC Final Status",
          align: "center",
        },
      ],
      "case approval": [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          minWidth: "130px",
        },
        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        {
          id: "customer_type",
          label: "Customer Type",
          align: "left",
        },
        {
          id: "Vendor name",
          label: "Vendor Name",
          align: "left",
        },
        {
          id: "claim_registration_date",
          label: "Claim Registration Date",
          align: "left",
        },
        {
          id: "reportSubmissionDate",
          label: "Report Submission Date",
          align: "left",
        },
        {
          id: "policy_number",
          label: "Policy No.",
          align: "left",
        },
        {
          id: "trigger_source",
          label: "Trigger Source",
          align: "center",
        },
        {
          id: "assigned_by_user_date",
          label: "Assigned Date",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        {
          id: "sub_product",
          label: "Sub Product",
          align: "center",
        },
        {
          id: "severity",
          label: "Severity",
          align: "center",
        },
        {
          id: "tat",
          label: "Over All TAT",
          align: "center",
        },
        {
          id: "caseCreatedBy",
          label: "Case Created By",
          align: "left",
        },
        {
          id: "loss_location",
          label: "Loss Location",
          align: "left",
        },
        {
          id: "loss_state",
          label: "State",
          align: "center",
        },
        {
          id: "loss_city",
          label: "City",
          align: "center",
        },
      ],
      closed: [
        // {
        //   id: "srNo",
        //   label: "Sr. No",
        //   align: "left",
        // },
        {
          id: "case_id",
          label: "Case No.",
          align: "left",
          color: "red",
          cursor: "pointer",
        },
        {
          id: "claim_no",
          label: "Claim No.",
          align: "left",
          width: "130px",
        },
        {
          id: "policy_number",
          label: "Policy No",
          align: "left",
        },

        {
          id: "customer_name",
          label: "Customer Name",
          align: "left",
        },
        // {
        //   id: "customer_type",
        //   label: "Customer Type",
        //   align: "left",
        // },
        {
          id: "claim_registration_date",
          label: "Claim Registration Date",
          align: "left",
        },
        {
          id: "lob_name",
          label: "LOB",
          align: "left",
        },
        // {
        //   id: "tigger_source",
        //   label: "Trigger Source",
        //   align: "center",
        // },
        {
          id: "severity",
          label: "Severity",
          align: "left",
        },
        {
          id: "im_name",
          label: "IM",
          align: "left",
          color: "red",
          fontWeight: "500",
        },
        {
          id: "qc_name",
          label: "QC",
          align: "left",
          color: "red",
          fontWeight: "500",
        },
        {
          id: "rm_name",
          label: "RM",
          align: "left",
          color: "red",
          fontWeight: "500",
        },
        {
          id: "nm_name",
          label: "NM",
          align: "left",
          color: "#4DC84D",
          fontWeight: "500",
        },
        {
          id: "nh_name",
          label: "NH",
          align: "left",
          fontWeight: "500",
          color: "#4DC84D",
        },
        {
          id: "qc_final_status",
          label: "QC Final Status",
          align: "center",
        },
        {
          id: "sendReminder",
          label: "Send Reminder",
          align: "left",
          fontWeight: "500",
          color: "#1395CC",
        },
        {
          id: "concludedat",
          label: "Closure Date",
          align: "left",
          minWidth: "100px",
        },
      ],
    },
    row: [
      {
        srNo: 5,
        case_id: 25,
        claim_no: "C1234567890",
        customer_name: "PARAMESH VERAPPA H C",
        product_name: "Motor",
        sub_product: "-",
        loss_state: "Maharashtra",
        loss_city: "Mumbai",
        assigned_by_user_date: "02/10/2022",
        registration_date: "02/10/2022",
        severity: "-",
        tat: 2,
        segmentation: "Women",
        alert: (
          <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
              fill="#E42125"
            />
            <path
              d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
              fill="#FFFCF2"
            />
            <path
              d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
              fill="#FFFCF2"
            />
          </svg>
        ),
        code: "",
      },
    ],
  },
];
